'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculatePixelsToShrinkBy = calculatePixelsToShrinkBy;

var _calculateMaxWidgetHeight = require('./calculateMaxWidgetHeight');

var _calculateMinWidgetHeight = require('./calculateMinWidgetHeight');

function calculatePixelsToShrinkBy(windowHeight, _ref) {
  var showCloseButton = _ref.showCloseButton;

  var maxWidgetHeight = (0, _calculateMaxWidgetHeight.calculateMaxWidgetHeight)({ showCloseButton: showCloseButton });
  var minWidgetHeight = (0, _calculateMinWidgetHeight.calculateMinWidgetHeight)({ showCloseButton: showCloseButton });

  if (windowHeight >= maxWidgetHeight) {
    return 0;
  }

  if (windowHeight <= minWidgetHeight) {
    return maxWidgetHeight - minWidgetHeight;
  }

  return maxWidgetHeight - windowHeight;
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.5219/js/widget-dimensions/util/calculatePixelsToShrinkBy.js
// module id = 1043
// module chunks = 2 3